<template>
  <div class="lyear-layout-web">
    <div class="lyear-layout-container">
      <!--左侧导航-->
      <user-left></user-left>
      <!--End 左侧导航-->
      
      <!--头部信息-->
      <user-head></user-head>
      <!--End 头部信息-->
      
      <!--页面主要内容-->
      <main class="lyear-layout-content">
        
        <div class="container-fluid">
          
          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-body">
                  
                  <form action="#!" method="post" class="row">
                    <div class="form-group col-md-12">
                      <label for="type">栏目</label>
                      <div class="form-controls mt-5">
												<Select v-model="childModal1"   @on-change="changeCate"  disabled>
														<Option v-for="item,index in cateList" :value="index" :key="item.id">{{ item.text }}</Option>
												</Select>
												<Select v-model="childModal" v-show="is_childrenCate"  @on-change="changeChild" class="mt-5" placeholder="请选择子分类" disabled>
														<Option v-for="item,index in cateList_c" :value="index" :key="item.id">{{ item.text }}</Option>
												</Select>
                      </div>
                    </div>
                    <div class="form-group col-md-12">
                      <label for="title">标题</label>
                      <Input type="text" class="mt-5" v-model="SYS_TOPIC" placeholder="请输入标题" disabled/>
                    </div>
										<div class="form-group col-md-12">
										  <label for="title">创建人</label>
										  <Input type="text" class="mt-5" v-model="CREATER" placeholder="请输入创建人" disabled />
										</div>
										<div class="form-group col-md-12">
										  <label for="title">作者</label>
										  <Input type="text" class="mt-5" v-model="SYS_AUTHORS" placeholder="请输入作者" disabled />
										</div>
                   <!-- <div class="form-group col-md-12">
                      <label for="seo_keywords">关键词</label>
                      <input type="text" class="form-control" id="seo_keywords" name="seo_keywords" value="" placeholder="关键词" />
                    </div> -->
                    <div class="form-group col-md-12">
                      <label for="seo_description">描述</label>
                      <Input class="mt-5" type="textarea" v-model="DESCRIPTION" placeholder="描述" disabled />
                    </div>
										<div  class="form-group col-md-12">
											<label for="seo_description">类型</label>
											<div class="mt-5">
												<RadioGroup v-model="DOC_TYPE" disabled>
														<Radio label="1" disabled><span class="f-14 c-66 ml-5">图片</span></Radio>
														<Radio label="2" disabled><span class="f-14 c-66 ml-5">组图</span></Radio>
												</RadioGroup>
											</div>
										</div>
                    <div class="form-group col-md-12">
                      <label>{{DOC_TYPE==1?'单图上传':'多图上传'}}</label>
                      <div class="form-controls mt-5">
                        <ul class="list-inline clearfix lyear-uploads-pic">
                          <li class="col-xs-4 col-sm-3 col-md-2 flex-c" style="display: flex;" v-for="item,index in defaultList" :key="index">
														<figure class="flex-c">
																<img  :src="item.url" alt="" class="upload-img" />
                              <figcaption>
                                <a class="btn btn-round btn-square btn-primary" @click="prewImgdel(item.url)"><i class="mdi mdi-eye"></i></a>
                                <a class="btn btn-round btn-square btn-danger"  @click="uploadImgdel(index)"><i class="mdi mdi-delete"></i></a>
                              </figcaption>
                            </figure>
                          </li>
                  
                        </ul>
                      </div>
                    </div>
                   <!-- <div class="form-group col-md-12">
                      <label for="content">内容</label>
                      <p>HTML编辑器这里就不做演示了</p>
                    </div> -->
                    <!-- <div class="form-group col-md-12">
                      <label for="tags">标签</label>
                      <input class="js-tags-input form-control" type="text" id="tags" name="tags" value="" />
                    </div> -->
                    <!-- <div class="form-group col-md-12">
                      <label for="sort">排序</label>
                      <input type="text" class="form-control" id="sort" name="sort" value="0" />
                    </div> -->
                <!--    <div class="form-group col-md-12">
                      <label for="status">状态</label>
                      <div class="clearfix">
                        <label class="lyear-radio radio-inline radio-primary">
                          <input type="radio" name="status" value="0"><span>禁用</span>
                        </label>
                        <label class="lyear-radio radio-inline radio-primary">
                          <input type="radio" name="status" value="1" checked><span>启用</span>
                        </label>
                      </div>
                    </div> -->
                    
                  </form>
         
                </div>
              </div>
            </div>
            
          </div>
          
        </div>
        
      </main>
      <!--End 页面主要内容-->
    </div>
		
		  <Modal
					v-model="showPrew"
					:footer-hide="true"
					:closable="false"
					class="abc"
					>
					<img :src="prewimg_now" alt="" />
			</Modal>
  </div>
</template>

<script>
import userLeft from './user_left.vue'
import userHead from './user_head.vue'
export default {
  data () {
    return {
			cateList: [], // 分类列表 大
			cateList_c: [], // 小
			PIC_p: 0 , // 分类父id
			PIC_p_t: 0 , // 分类父id
			PIC_CASCADID: '' , // 分类父id
			is_childrenCate: false,
			PIC_CATID: 0, // 子分类id
			PIC_CAT:'', // 支付类名称
			childModal:'',
			childModal1: '',
			SYS_TOPIC: '' , // 标题
			DESCRIPTION: '', // 描述
			DOC_TYPE: '1', // 上传类型 1图片 2组图
			defaultList: [],  // { name: 'img2.jpg',url: 'http://www.xxx.com/img2.jpg'}
			tokenStr: localStorage.getItem('token') || '',
			nameArr: [],
			FILES: [],
			CREATER: '', // 创建人 不能修改
			SYS_AUTHORS: '', // 作者 默认当前可修改
			showPrew: false,
			prewimg_now: '',
			id: 0,
			z_catesname:0
		}
  },
	
	components: {
		userLeft,
		userHead
	},
	
  created () {
		this.userInfo()
		this.id = this.$route.query.id || 0
	},
	
	mounted () {
		this.imgcateList()
		if (this.id) {
			this.tgDetail()
		}
	},

  methods: {
		// 提交发布投稿
		async submitFile () {
			let _this = this
			let { PIC_CATID, PIC_CAT, PIC_CASCADID, SYS_TOPIC, DOC_TYPE, DESCRIPTION, FILES, CREATER, SYS_AUTHORS } = _this
			if (!PIC_CATID) {
				return _this.util.showMsg('warning','请选择分类',3,false)
			}
			if (!SYS_TOPIC) {
				return _this.util.showMsg('warning','请输入标题',3,false)
			}
			if (!SYS_AUTHORS) {
				return _this.util.showMsg('warning','请填写作者',3,false)
			}
			if (!FILES.length) {
				return _this.util.showMsg('warning','请上传对应图片',3,false)
			}
			const res = await _this.post_res('/devote/addDevote.do', {
				PIC_CAT_ID:_this.PIC_CATID, TUPIANLAIYUAN:'作者投稿', PIC_CAT, PIC_CAT_CASCADID: _this.PIC_CASCADID, SYS_TOPIC, DOC_TYPE:DOC_TYPE, DESCRIPTION, FILES, CREATER, SYS_AUTHORS, PIC_NUM:FILES.length + ''
			})
			if (res.status == 0) {
				_this.util.showMsg('success',res.data,3,false)
				_this.childModal = ''
				_this.childModal1 = ''
				_this.PIC_CASCADID = ''
				_this.PIC_CATID = 0
				_this.PIC_CAT = ''
				_this.SYS_TOPIC = ''
				_this.DESCRIPTION = ''
				_this.DOC_TYPE = '1'
				_this.defaultList = []
				_this.FILES = []
				_this.nameArr = []
				setTimeout( () => {
					_this.$router.replace({path: '/userDepot'})
				},3000)
			} else {
				_this.util.showMsg('error',res.message,3,false)
			}
		},
		
		// 获取投稿详情
		async tgDetail () {
			let _this = this
			_this.$Spin.show()
			const res = await _this.get_res('/devote/getDetail.do?id=' + _this.id)
			_this.SYS_AUTHORS = res.data.SYS_AUTHORS
			_this.DESCRIPTION = res.data.DESCRIPTION
			_this.SYS_TOPIC = res.data.SYS_TOPIC
			_this.DOC_TYPE = res.data.DOC_TYPE + ''
			let index = res.data.PIC_CAT.indexOf('~')
			_this.disposeCate(res.data.PIC_CAT.substr(0,index), res.data.PIC_CAT.substr(index+1))
			res.data.files.forEach(x => {
				_this.FILES.push({fileRecordId:x.fileRecordID,fileName: x.attachName})
				_this.defaultList.push({fileRecordId:x.fileRecordID,url: x.middlePath})
				_this.nameArr.push(x.attachName)
			})
		},
		
		// 处理分类的方法
		disposeCate (a,b) {
			let _this = this
			_this.cateList.forEach((x,index) => {
				if (x.text == a) {
					_this.childModal1 = index
					_this.changeCate(index)
				}
			})
			_this.z_catesname = b || 0
		},
		disposeCatez (name) {
			let _this = this
			_this.cateList_c.forEach((x,index) => {
				if (x.text == name) {
					_this.childModal = index
					_this.changeChild(index)
				}
			})
			
			_this.$Spin.hide()
		},
		
		// 获取图片分类接口
		async imgcateList (parentId=0) {
			let _this = this
			const res = await _this.get_res('/catsByCatCode', {catTypeCode: 'MATERIAL-PIC', parentId})
			if (parentId) {
				_this.cateList_c = res
				_this.z_catesname && _this.disposeCatez(_this.z_catesname)
			} else {
				_this.cateList = res
			}
		},
		
		// 获取用户信息
		async userInfo () {
			let _this = this
			const tokenState = await this.util.checkToken(localStorage.getItem('token'))
			_this.CREATER = tokenState.data.loginName
			_this.SYS_AUTHORS = tokenState.data.username
		},
		
		// 选择大分类
		changeCate (index) {
			let _this = this
			if (index === undefined) {
				return
			}
			_this.PIC_p = _this.cateList[index].id
			_this.PIC_p_t = _this.cateList[index].text
			_this.is_childrenCate = _this.cateList[index].children
			_this.PIC_CATID = 0
			_this.PIC_CAT = ''
			_this.PIC_CASCADID = ''
			if (!_this.is_childrenCate) {
				_this.PIC_CATID = _this.PIC_p
				_this.PIC_CAT = _this.PIC_p_t
			}
			_this.childModal = ''
			_this.imgcateList(_this.PIC_p)
		},
		
		// 选择子分类
		changeChild (index) {
			let _this = this
			if (index === undefined) {
				return
			}
			_this.PIC_CATID = _this.cateList_c[index].id
			_this.PIC_CASCADID = _this.PIC_p + '_' + _this.PIC_CATID
			_this.PIC_CAT = _this.PIC_p_t + '~' +_this.cateList_c[index].text
			console.log(_this.PIC_CAT,_this.PIC_CASCADID)
		},
		
		// 文件上传成功时的钩子
		async handleSuccess (response, file, fileList) {
			let _this = this
				_this.defaultList.push(response)
				_this.FILES =[]
				_this.defaultList.forEach((x,index) => {
					_this.FILES.push({fileName: _this.nameArr[index], fileRecordId: x.fileRecordId-0})
				})
				this.$Spin.hide()
		},
		handleBefore (e) {
				this.$Spin.show()
				this.nameArr.push(e.name)
		},

		
		// 删除上传的图片
		uploadImgdel (index) {
			this.defaultList.splice(index, 1)
			this.FILES.splice(index, 1)
		},
		
		prewImgdel (url) {
			this.prewimg_now = url
			this.showPrew = true
		}
	}
}
</script>

<style lang="less" >
.ivu-upload,.ivu-upload-select {width: 100%;}
.lyear-uploads-pic figure img.upload-img {
	max-width: 177px;
	max-height: 177px;
	vertical-align: middle;
}
.lyear-uploads-pic figure {
	width: 177px;
	height: 177px;
}
.abc .ivu-modal-content {
	background-color: rgba(0,0,0,0);
}
.abc .ivu-modal-body {
	padding: 0!important;
}
.abc img {
	width: 100%;
}
</style>
